export class StpTradeResult {
  tradeId: string;
  tradeTime: Date;
  tradingParty: string;
  counterParty: string;
  currencyPair: string;
  direction: string;
  quantity: number;
  price: number;
  tradeDate: string;
  valueDate: string;

  constructor(tradeId: string, tradeTime: Date, tradingParty: string, counterParty: string, currencyPair: string, direction: string, quantity: number, price: number, tradeDate: any, valueDate: string) {
    this.tradeId = tradeId;
    this.tradeTime = tradeTime;
    this.tradingParty = tradingParty;
    this.counterParty = counterParty;
    this.currencyPair = currencyPair;
    this.direction = direction;
    this.quantity = quantity;
    this.price = price;
    this.tradeDate = tradeDate;
    this.valueDate = valueDate;
  }
}
